<template>
    <b-card>
        <b-card-header>
            <b-row>
                <b-col class="col-md-10">
                    <b-input
                        type="search"
                        placeholder="Filter..."
                        v-model="query"
                        @input="updateQuery"
                    ></b-input>
                </b-col>
                <b-col class="col text-right">
                    <b-button variant="primary" @click="$emit('add-role')"
                        >Add Role</b-button
                    >
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-table id="roleTable" responsive :items="roles" :fields="fields">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="view(row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
//import autoTable from 'jspdf-autotable'
export default {
    name: 'role-table',
    mixins: [popupMixins],   
    data() {
        return {
            query: '',
            page: 1,
            //template: false,
            fields: [{ key: 'id', label: 'Actions' }, 'name'],
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        updateQuery: _.debounce(function(query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function(page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            this.$store.dispatch('roles/fetch', {
                query: this.query,
                page: this.page,
            })
        },
        view(index) {
              const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    watch: {
        'pagination.page': function(newPage) {
            this.changePage(newPage)
        },
    },

    computed: {
        roles() {
            return this.$store.state.roles.items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.roles.pagination || []
        },
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
